import ApiService from '../apiservice'

export default class PessoaService extends ApiService {

  constructor() {
    super('/pessoas')
  }

  cadastrarPessoa(pessoa) {
    return this.post('/',pessoa);
  }

  cadastrarPessoaProcesso(pessoa) {
    return this.post('/processo',pessoa);
  }

  listarPessoas(empresa) {
    return this.get(`/porEmpresa/${empresa}`);
  }

  listarPessoasEmpresaPerfil(empresa, perfil) {
    return this.get(`/porEmpresaPerfil?empresa=${empresa}&perfil=${perfil}`);
  }

  listarPessoasForaDasPartesProcesso(filtro) {
    return this.get(`/foraPartes?empresa=${filtro.empresa}&processo=${filtro.processo}&perfil=${filtro.perfil}`);
  }

  consultarPessoas(filtro) {
    
    let params = `?empresa=${filtro.empresa}&usuario=${filtro.usuario}`;

    if(filtro.nome != null) {
      params = `${params}&nome=${filtro.nome}`;
    }

    if(filtro.cpfCnpj != null) {
      params = `${params}&cpfCnpj=${filtro.cpfCnpj}`;
    }

    if(filtro.estado != null) {
      params = `${params}&estado=${filtro.estado}`;
    }

    if(filtro.cidade != null) {
      params = `${params}&cidade=${filtro.cidade}`;
    }

    if(filtro.telefone != null && filtro.telefone != "") {
      params = `${params}&telefone=${filtro.telefone}`;
    }

    if(filtro.email != null && filtro.email != "") {
      params = `${params}&email=${filtro.email}`;
    }

    if(filtro.profissao != null) {
      params = `${params}&profissao=${filtro.profissao}`;
    }

    if(filtro.porLetra != null) {
      params = `${params}&letra=${filtro.letra}&porLetra=${filtro.porLetra}`;
    }

    if(filtro.grupo != null) {
      params = `${params}&grupo=${filtro.grupo}`;
    }

    if(filtro.dataNascimento != null) {
      params = `${params}&dataNascimento=${filtro.dataNascimento}`;
    }

    if(filtro.operadorLogico != null) {
      params = `${params}&operadorLogico=${filtro.operadorLogico}`;
    }

    if(filtro.idade != null) {
      params = `${params}&idade=${filtro.idade}`;
    }

    if(filtro.dataCadastroInicial != null && filtro.dataCadastroFinal != null) {
      params = `${params}&dataCadastroInicial=${filtro.dataCadastroInicial}&dataCadastroFinal=${filtro.dataCadastroFinal}`;
    }

    if(filtro.dataUltimoAtendimentoInicial != null && filtro.dataUltimoAtendimentoFinal != null) {
      params = `${params}&dataUltimoAtendimentoInicial=${filtro.dataUltimoAtendimentoInicial}&dataUltimoAtendimentoFinal=${filtro.dataUltimoAtendimentoFinal}`;
    }

    if(filtro.unidade != null) {
      params = `${params}&unidade=${filtro.unidade}`;
    }
    
    return this.get(params);
  }

  consultarPessoa(codigo) {
    return this.get(`/${codigo}`)
  }

  listarPerfilPessoa() {
    return this.get('/perfisPessoa');
  }

  listarEstadoCivil() {
    return this.get('/estadoCivil');
  }

  listarTiposEndereco() {
    return this.get('/tiposEndereco');
  }

  excluirPessoa(codigo) {
    return this.delete(`/${codigo}`);
  }

  consultarProcessos(pessoa,usuario) {
    return this.get(`/processos?pessoa=${pessoa}&usuario=${usuario}`);
  }

  listarCaptadores(perfil, empresa) {
    return this.get(`/captadores?perfil=${perfil}&empresa=${empresa}`);
  }

  alterarPessoa(pessoa) {
    console.log('Pessoa ', pessoa);
    return this.put(`/${pessoa.codigo}`, pessoa);
  }

  consultarPessoasPorCodigos(codigos) {
    return this.get(`/pessoasPorCodigos?codigos=${codigos}`);
  }

  listarBancadas(empresa) {
    return this.get(`/bancadas/${empresa}`);
  }

  consultarPorNomeOuCpf(empresa,pesquisa) {
    return this.get(`/pesquisa-por-nome-cpf?empresa=${empresa}&pesquisa=${pesquisa}`);
  }

  listarProfissoes(empresa) {
    return this.get(`/profissoes?empresa=${empresa}`);
  }

  uploadFoto(id,file) {
    return this.post2(`/foto/${id}`,file);
  }

  carregarFoto(pessoaId) {
    return this.get2(`/${pessoaId}/foto`)
  }

  removerFoto(pessoaId) {
    return this.put(`/remover-foto/${pessoaId}`)
  }

  ativarInativarPessoa(codigo) {
    return this.put(`/ativar-inativar-pessoa/${codigo}`);
  }
}